<template>
	<div v-if="data" class="sub-values">
		<div class="sub-value clickable" @click="$emit('click')">
			<div class="label">Gehaltsbandbreite</div>
			<div>{{ data.salary.salary }} - {{ data.salary.salaryMax }} &euro;</div>
		</div>
		<div
			v-if="withCollective && data.salaryCollective && data.salaryCollective.collective !== 'none'"
			class="sub-value clickable"
			@click="$emit('click')"
		>
			<div class="label">Mindestgehalt</div>
			<div>
				<template v-if="data.salaryCollective.collective === 'unknown'">Unbekannt</template>
				<template v-else>{{ data.salaryCollective.salary }} &euro;</template>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			required: false
		},
		withCollective: {
			type: Boolean,
			required: false,
			default: true
		}
	},
}
</script>
